// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-group-details {
  padding: 8px 4px 32px;
  max-width: 720px;
  margin: 0 auto;
  min-height: 0;
  background: transparent;
  color: var(--vb-text);
  box-sizing: border-box;
}

.details-header {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding: 4px 0 10px;
  border-bottom: 1px solid var(--vb-border);
}

.details-header h1 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.02em;
  text-align: left;
  text-transform: none;
  color: var(--vb-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--vb-surface);
  color: var(--vb-text);
  border: 1px solid var(--vb-border);
  padding: 8px 12px;
  min-height: 40px;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 13px;
  font-weight: 650;
  flex-shrink: 0;
}

.series-overview { margin-bottom: 16px; }

.series-info-card {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 14px;
  padding: 12px;
  box-shadow: var(--vb-shadow-sm);
  min-width: 0;
  overflow: hidden;
}

.series-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  min-width: 0;
}

.series-org {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.type-badge {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: var(--vb-radius-pill);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.type-badge.league { background: #dbeafe; color: #1d4ed8; }
.type-badge.tournament { background: #ffedd5; color: #c2410c; }
.type-badge.scrimmage { background: #dcfce7; color: #15803d; }
.type-badge.school { background: #f3e8ff; color: #7e22ce; }

.series-board {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.series-row,
.set-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 7px 8px;
  border-radius: 10px;
  background: var(--vb-surface-2);
}

.set-row { grid-template-columns: minmax(0, 1fr) auto; }

.series-row.is-winner,
.set-row.is-winner {
  background: var(--vb-success-soft);
}

.series-team-name {
  min-width: 0;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.25;
  color: var(--vb-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.series-row.is-winner .series-team-name,
.set-row.is-winner .series-team-name { font-weight: 800; }

.series-pips {
  display: flex;
  gap: 3px;
  flex-shrink: 0;
}

.pip {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--vb-border-strong);
}
.pip.on { background: var(--vb-primary); }
.series-row.is-winner .pip.on { background: var(--vb-success); }

.series-set-score,
.set-points {
  font-family: var(--vb-font-score);
  font-weight: 800;
  line-height: 1;
  text-align: right;
  color: var(--vb-text);
}
.series-set-score { font-size: 24px; min-width: 1.2em; }
.set-points { font-size: 20px; min-width: 1.6em; }

.series-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
  font-size: 12px;
  color: var(--vb-text-muted);
  font-weight: 600;
}

.series-complete {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 8px 10px;
  background: var(--vb-success-soft);
  color: var(--vb-success);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.series-note {
  margin: 10px 0 0;
  padding: 8px 10px;
  background: var(--vb-warning-soft);
  border-radius: 8px;
  font-size: 12px;
  color: var(--vb-text);
}

.sets-section h3 {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 800;
  color: var(--vb-text);
  text-align: left;
  text-transform: none;
}

.empty-sets {
  text-align: center;
  padding: 32px 12px;
  color: var(--vb-text-muted);
  font-size: 13px;
}
.empty-sets svg { margin-bottom: 8px; opacity: 0.4; }

.sets-list { display: flex; flex-direction: column; gap: 8px; }

.set-card {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  padding: 10px 12px;
  min-width: 0;
  overflow: hidden;
}

.set-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
}

.set-header h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
  color: var(--vb-text);
}

.set-date {
  font-size: 11px;
  color: var(--vb-text-muted);
  font-weight: 600;
  white-space: nowrap;
}

.set-score {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.set-details {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--vb-text-muted);
  font-size: 12px;
  min-width: 0;
}

.detail-item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.loading, .error-message {
  text-align: center;
  padding: 24px 12px;
  font-size: 14px;
}

.error-message {
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
  border-radius: 10px;
  font-weight: 650;
}

@media (min-width: 640px) {
  .match-group-details { padding: 12px 8px 40px; }
  .details-header h1 { font-size: 18px; }
  .series-team-name { font-size: 14px; }
  .series-set-score { font-size: 28px; }
}

@media (max-width: 379px) {
  .series-pips { display: none; }
  .back-btn span { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/MatchGroupDetails.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,qBAAqB;EACrB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,WAAW,0CAA0C,EAAE;;AAEvD;;EAEE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;uCACuC,gBAAgB,EAAE;;AAEzD;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA,UAAU,6BAA6B,EAAE;AACzC,gCAAgC,6BAA6B,EAAE;;AAE/D;;EAEE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;AACA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE;AACvD,cAAc,eAAe,EAAE,gBAAgB,EAAE;;AAEjD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;AACA,kBAAkB,kBAAkB,EAAE,YAAY,EAAE;;AAEpD,aAAa,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE9D;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB,sBAAsB,EAAE;EAC/C,qBAAqB,eAAe,EAAE;EACtC,oBAAoB,eAAe,EAAE;EACrC,oBAAoB,eAAe,EAAE;AACvC;;AAEA;EACE,eAAe,aAAa,EAAE;EAC9B,iBAAiB,aAAa,EAAE;AAClC","sourcesContent":[".match-group-details {\n  padding: 8px 4px 32px;\n  max-width: 720px;\n  margin: 0 auto;\n  min-height: 0;\n  background: transparent;\n  color: var(--vb-text);\n  box-sizing: border-box;\n}\n\n.details-header {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding: 4px 0 10px;\n  border-bottom: 1px solid var(--vb-border);\n}\n\n.details-header h1 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  text-align: left;\n  text-transform: none;\n  color: var(--vb-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  border: 1px solid var(--vb-border);\n  padding: 8px 12px;\n  min-height: 40px;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 650;\n  flex-shrink: 0;\n}\n\n.series-overview { margin-bottom: 16px; }\n\n.series-info-card {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 14px;\n  padding: 12px;\n  box-shadow: var(--vb-shadow-sm);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.series-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n  min-width: 0;\n}\n\n.series-org {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.type-badge {\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: var(--vb-radius-pill);\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.type-badge.league { background: #dbeafe; color: #1d4ed8; }\n.type-badge.tournament { background: #ffedd5; color: #c2410c; }\n.type-badge.scrimmage { background: #dcfce7; color: #15803d; }\n.type-badge.school { background: #f3e8ff; color: #7e22ce; }\n\n.series-board {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.series-row,\n.set-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 7px 8px;\n  border-radius: 10px;\n  background: var(--vb-surface-2);\n}\n\n.set-row { grid-template-columns: minmax(0, 1fr) auto; }\n\n.series-row.is-winner,\n.set-row.is-winner {\n  background: var(--vb-success-soft);\n}\n\n.series-team-name {\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 1.25;\n  color: var(--vb-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.series-row.is-winner .series-team-name,\n.set-row.is-winner .series-team-name { font-weight: 800; }\n\n.series-pips {\n  display: flex;\n  gap: 3px;\n  flex-shrink: 0;\n}\n\n.pip {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--vb-border-strong);\n}\n.pip.on { background: var(--vb-primary); }\n.series-row.is-winner .pip.on { background: var(--vb-success); }\n\n.series-set-score,\n.set-points {\n  font-family: var(--vb-font-score);\n  font-weight: 800;\n  line-height: 1;\n  text-align: right;\n  color: var(--vb-text);\n}\n.series-set-score { font-size: 24px; min-width: 1.2em; }\n.set-points { font-size: 20px; min-width: 1.6em; }\n\n.series-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 10px;\n  font-size: 12px;\n  color: var(--vb-text-muted);\n  font-weight: 600;\n}\n\n.series-complete {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n  padding: 8px 10px;\n  background: var(--vb-success-soft);\n  color: var(--vb-success);\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.series-note {\n  margin: 10px 0 0;\n  padding: 8px 10px;\n  background: var(--vb-warning-soft);\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--vb-text);\n}\n\n.sets-section h3 {\n  margin: 0 0 10px;\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--vb-text);\n  text-align: left;\n  text-transform: none;\n}\n\n.empty-sets {\n  text-align: center;\n  padding: 32px 12px;\n  color: var(--vb-text-muted);\n  font-size: 13px;\n}\n.empty-sets svg { margin-bottom: 8px; opacity: 0.4; }\n\n.sets-list { display: flex; flex-direction: column; gap: 8px; }\n\n.set-card {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  padding: 10px 12px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.set-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.set-header h4 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--vb-text);\n}\n\n.set-date {\n  font-size: 11px;\n  color: var(--vb-text-muted);\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.set-score {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.set-details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.detail-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--vb-text-muted);\n  font-size: 12px;\n  min-width: 0;\n}\n\n.detail-item span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.loading, .error-message {\n  text-align: center;\n  padding: 24px 12px;\n  font-size: 14px;\n}\n\n.error-message {\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n  border-radius: 10px;\n  font-weight: 650;\n}\n\n@media (min-width: 640px) {\n  .match-group-details { padding: 12px 8px 40px; }\n  .details-header h1 { font-size: 18px; }\n  .series-team-name { font-size: 14px; }\n  .series-set-score { font-size: 28px; }\n}\n\n@media (max-width: 379px) {\n  .series-pips { display: none; }\n  .back-btn span { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
